import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dHeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dPromotionsEngine$dMaximalCliques from "../Restaumatic.PromotionsEngine.MaximalCliques/index.js";
import * as Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion from "../Restaumatic.PromotionsEngine.Promotions.Types.Promotion/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const Promotion = x => x;
const udecodePromotion = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "autoAssignable"})(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "combineTo"
    })(Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.udecodePromotionFilter)(Unscramble.decodeRecordCons({reflectSymbol: () => "conditions"})(Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.unscrambleDecodePromotionConditions)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "prize"
    })(Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.unscrambleDecodePromotionPrize)(Unscramble.decodeRecordCons({reflectSymbol: () => "promotionId"})(Unscramble.decodeInt1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "promotionType"
    })(Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.unscrambleDecodePromotionType)(Unscramble.decodeRecordNil)))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const repeatable = v => Data$dRecord.unsafeGet("repeatable")(v);
const numRequiredItems = v => Data$dRecord.unsafeGet("numRequiredItems")(v);
const newtypePromotion = {Coercible0: () => {}};
const promotionCombineTo = x => x.combineTo;
const promotionConditions = x => x.conditions;
const promotionId = x => x.promotionId;
const promotionPrize = x => x.prize;
const promotionFreebies = promo => {
  if (promo.prize.tag === "Freeby") { return Data$dMaybe.$Maybe("Just", promo.prize._1); }
  return Data$dMaybe.Nothing;
};
const promotionTarget = promotion => {
  if (promotion.conditions.tag === "CartPromotion") { return Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.CartTarget; }
  if (promotion.conditions.tag === "ProductPromotion") { return Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.ProductTarget; }
  $runtime.fail();
};
const promotionType = x => x.promotionType;
const showPromotion = {
  show: promotion => "Promotion\n{ promotionId:    " + Data$dShow.showIntImpl(promotion.promotionId) + "\n, promotionType:  " + Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.showPromotionType.show(promotion.promotionType) + "\n, conditions:     " + Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.showPromotionConditions.show(promotion.conditions) + "\n, prize:          " + Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.showPromotionPrize.show(promotion.prize) + "\n, combineTo:      " + Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.showPromotionFilter.show(promotion.combineTo) + (promotion.autoAssignable
    ? "\n, autoAssignable: true\n}"
    : "\n, autoAssignable: false\n}")
};
const mkPromotionNoneFilter = /* #__PURE__ */ Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.$PromotionFilter([]);
const mkPromotionIdFilter = Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.PromotionIdFilter;
const mkPromotion = promoId => promoFilter => promoType => conds => prz => (
  {promotionId: promoId, promotionType: promoType, conditions: conds, prize: prz, combineTo: promoFilter, autoAssignable: true}
);
const mkProductPromotionRequirements = prodFilter => repeat => numReqItems => ({productFilter: prodFilter, repeatable: repeat, numRequiredItems: numReqItems});
const mkProductPromotion = promoId => promoFilter => promoType => reqs => prz => (
  {
    promotionId: promoId,
    promotionType: promoType,
    conditions: Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.$PromotionConditions("ProductPromotion", reqs),
    prize: prz,
    combineTo: promoFilter,
    autoAssignable: true
  }
);
const mkFreeProducts = value => vatRate => Data$dFunctor.arrayMap(name => ({productName: name, productValue: value, vatRate}));
const mkCartPromotion = promoId => promoFilter => promoType => reqs => prz => (
  {
    promotionId: promoId,
    promotionType: promoType,
    conditions: Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.$PromotionConditions("CartPromotion", reqs),
    prize: prz,
    combineTo: promoFilter,
    autoAssignable: true
  }
);
const isTextPromotion = promotion => Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.eqPromotionPrize.eq(promotion.prize)(Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.TextInformation);
const isProductPromotion = x => {
  if (x.conditions.tag === "CartPromotion") { return false; }
  if (x.conditions.tag === "ProductPromotion") { return true; }
  $runtime.fail();
};
const isCouponPromotion = promo => Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.eqPromotionPrize.eq(promo.prize)(Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.CouponValue);
const isCartPromotionOf = cartPromotionRequirement => promotion => {
  if (promotion.conditions.tag === "CartPromotion") {
    if (promotion.conditions._1.tag === "CartValue") {
      if (cartPromotionRequirement.tag === "CartValue") { return promotion.conditions._1._1.minCartValue === cartPromotionRequirement._1.minCartValue; }
      return false;
    }
    if (promotion.conditions._1.tag === "FirstOrder") { return cartPromotionRequirement.tag === "FirstOrder"; }
    if (promotion.conditions._1.tag === "Loyalty") { return cartPromotionRequirement.tag === "Loyalty"; }
    if (promotion.conditions._1.tag === "HasCoupon") { return cartPromotionRequirement.tag === "HasCoupon"; }
    if (promotion.conditions._1.tag === "Always") { return cartPromotionRequirement.tag === "Always"; }
    if (promotion.conditions._1.tag === "Never") { return cartPromotionRequirement.tag === "Never"; }
    return false;
  }
  if (promotion.conditions.tag === "ProductPromotion") { return false; }
  $runtime.fail();
};
const isFirstOrderPromotion = promotion => {
  if (promotion.conditions.tag === "CartPromotion") {
    if (promotion.conditions._1.tag === "CartValue") { return false; }
    return promotion.conditions._1.tag === "FirstOrder";
  }
  if (promotion.conditions.tag === "ProductPromotion") { return false; }
  $runtime.fail();
};
const isLoyaltyPromotion = promotion => {
  if (promotion.conditions.tag === "CartPromotion") {
    if (promotion.conditions._1.tag === "CartValue") { return false; }
    if (promotion.conditions._1.tag === "FirstOrder") { return false; }
    return promotion.conditions._1.tag === "Loyalty";
  }
  if (promotion.conditions.tag === "ProductPromotion") { return false; }
  $runtime.fail();
};
const isCartPromotion = x => {
  if (x.conditions.tag === "CartPromotion") { return true; }
  if (x.conditions.tag === "ProductPromotion") { return false; }
  $runtime.fail();
};
const isAutoAssignablePromotion = x => x.autoAssignable;
const inPromotionFilter = promotion => filter => {
  const $0 = promotion.promotionId;
  return Data$dFoldable.foldableArray.foldMap({mempty: false, Semigroup0: () => ({append: v => v1 => v || v1})})($1 => $0 === $1)(filter._1);
};
const getFirstPromotionFreeby = promo => {
  if (promo.prize.tag === "Freeby") { return Data$dArray.index(promo.prize._1)(0); }
  return Data$dMaybe.Nothing;
};
const genericPromotion = {to: x => x, from: x => x};
const freeProductValue = v => Data$dRecord.unsafeGet("productValue")(v);
const freeProductName = v => Data$dRecord.unsafeGet("productName")(v);
const getFirstPromotionFreebyName = promo => {
  const $0 = promo.prize.tag === "Freeby" ? Data$dArray.index(promo.prize._1)(0) : Data$dMaybe.Nothing;
  if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", Data$dRecord.unsafeGet("productName")($0._1)); }
  return Data$dMaybe.Nothing;
};
const isInPromotionFreebies = freeby => promo => {
  if (promo.prize.tag === "Freeby") {
    return Data$dFoldable.foldableArray.foldMap({mempty: false, Semigroup0: () => ({append: v => v1 => v || v1})})($0 => freeby === $0)(Data$dFunctor.arrayMap(freeProductName)(promo.prize._1));
  }
  return false;
};
const findPromotionFreeby = freeby => promo => {
  if (promo.prize.tag === "Freeby") {
    return Data$dFoldable.find(Data$dFoldable.foldableArray)(freeProduct => freeby === Data$dRecord.unsafeGet("productName")(freeProduct))(promo.prize._1);
  }
  return Data$dMaybe.Nothing;
};
const eqPromotion = {
  eq: x => y => x.autoAssignable === y.autoAssignable && Data$dEq.eqArrayImpl(Data$dEq.eqIntImpl)(x.combineTo._1)(y.combineTo._1) && Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.eqPromotionConditions.eq(x.conditions)(y.conditions) && Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.eqPromotionPrize.eq(x.prize)(y.prize) && x.promotionId === y.promotionId && (() => {
    if (x.promotionType.tag === "Standard") { return y.promotionType.tag === "Standard"; }
    if (x.promotionType.tag === "InformationOnly") { return y.promotionType.tag === "InformationOnly"; }
    if (x.promotionType.tag === "RequiresCoupon") { return y.promotionType.tag === "RequiresCoupon"; }
    return false;
  })()
};
const ordPromotion = {
  compare: a => b => Data$dFoldable.foldableArray.foldMap(Data$dMonoid.monoidOrdering)(x => x)([
    Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.ordPromotionConditions.compare(a.conditions)(b.conditions),
    Data$dOrd.ordInt.compare(a.promotionId)(b.promotionId)
  ]),
  Eq0: () => eqPromotion
};
const encodePromotion = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericPromotion)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Promotion"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "promotionType"
    })({encodeWithOptions: v => Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.encodePromotionType.encode}))({reflectSymbol: () => "promotionId"})({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))({reflectSymbol: () => "prize"})({encodeWithOptions: v => Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.encodePromotionPrize.encode}))({
      reflectSymbol: () => "conditions"
    })({encodeWithOptions: v => Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.encodePromotionConditions.encode}))({reflectSymbol: () => "combineTo"})({
      encodeWithOptions: v => Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.encodePromotionFilter.encode
    }))({reflectSymbol: () => "autoAssignable"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const defaultPromotionFilter = /* #__PURE__ */ Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.$PromotionFilter([]);
const decodePromotion = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericPromotion)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "Promotion"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "promotionType"
  })({decodeWithOptions: v => Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.decodePromotionType.decode})())({reflectSymbol: () => "promotionId"})({
    decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)
  })())({reflectSymbol: () => "prize"})({decodeWithOptions: v => Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.decodePromotionPrize.decode})())({
    reflectSymbol: () => "conditions"
  })({decodeWithOptions: v => Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.decodePromotionConditions.decode})())({reflectSymbol: () => "combineTo"})({
    decodeWithOptions: v => Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.decodePromotionFilter.decode
  })())({reflectSymbol: () => "autoAssignable"})({decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const canCombineTo = promotion => otherPromotion => !eqPromotion.eq(promotion)(otherPromotion) && inPromotionFilter(otherPromotion)(promotion.combineTo);
const canCombineToAll = promotion => promotions => Data$dFoldable.foldlArray(Data$dHeytingAlgebra.boolConj)(true)(Data$dFunctor.arrayMap(v => !eqPromotion.eq(v)(promotion) && inPromotionFilter(promotion)(v.combineTo))(promotions));
const canCombineWith = otherPromotion => promotion => !eqPromotion.eq(promotion)(otherPromotion) && inPromotionFilter(otherPromotion)(promotion.combineTo) && !eqPromotion.eq(otherPromotion)(promotion) && inPromotionFilter(promotion)(otherPromotion.combineTo);
const canCombineWithAll = promotion => promotions => Data$dFoldable.foldlArray(Data$dHeytingAlgebra.boolConj)(true)(Data$dFunctor.arrayMap(v => canCombineWith(v)(promotion))(promotions));
const canCombineWithAllOthers = promotion => promotions => canCombineWithAll(promotion)(Data$dArray.filter(promo => !eqPromotion.eq(promo)(promotion))(promotions));
const combineableClique = promotions => {
  const $0 = Data$dArray.index(Restaumatic$dPromotionsEngine$dMaximalCliques.getMaximalCliques(canCombineWith)(promotions))(0);
  if ($0.tag === "Nothing") { return []; }
  if ($0.tag === "Just") { return $0._1; }
  $runtime.fail();
};
const allCombineable = promotion => Data$dArray.filter(canCombineWith(promotion));
export {
  Promotion,
  allCombineable,
  canCombineTo,
  canCombineToAll,
  canCombineWith,
  canCombineWithAll,
  canCombineWithAllOthers,
  combineableClique,
  decodePromotion,
  defaultPromotionFilter,
  encodePromotion,
  eqPromotion,
  findPromotionFreeby,
  freeProductName,
  freeProductValue,
  genericPromotion,
  getFirstPromotionFreeby,
  getFirstPromotionFreebyName,
  inPromotionFilter,
  isAutoAssignablePromotion,
  isCartPromotion,
  isCartPromotionOf,
  isCouponPromotion,
  isFirstOrderPromotion,
  isInPromotionFreebies,
  isLoyaltyPromotion,
  isProductPromotion,
  isTextPromotion,
  mkCartPromotion,
  mkFreeProducts,
  mkProductPromotion,
  mkProductPromotionRequirements,
  mkPromotion,
  mkPromotionIdFilter,
  mkPromotionNoneFilter,
  newtypePromotion,
  numRequiredItems,
  ordPromotion,
  promotionCombineTo,
  promotionConditions,
  promotionFreebies,
  promotionId,
  promotionPrize,
  promotionTarget,
  promotionType,
  repeatable,
  showPromotion,
  udecodePromotion
};
